import { cssAnimation } from '../../wui-core/src';
import { prefix } from "../../wui-core/src/index.js";

function animate(node, show, done) {
  var height;
  return cssAnimation(node, "".concat(prefix, "-motion-collapse"), {
    start: function start() {
      if (!show) {
        node.style.height = "".concat(node.offsetHeight, "px");
      } else {
        height = node.offsetHeight;
        node.style.height = 0;
      }
    },
    active: function active() {
      node.style.height = "".concat(show ? height : 0, "px");
    },
    end: function end() {
      node.style.height = '';
      done();
    }
  });
}

var animation = {
  enter: function enter(node, done) {
    return animate(node, true, done);
  },
  leave: function leave(node, done) {
    return animate(node, false, done);
  },
  appear: function appear(node, done) {
    return animate(node, true, done);
  }
};
export default animation;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-tree/src/openAnimation.js